import { AI_INSTRUCTIONS_DIRECTORY, CLAUDE_PROVIDER, PROVIDERS } from '../../constants'
import { initClaude } from '../../operations/init-claude'
import { fail } from '../fail'
import { say, section } from '../output'
import { reportInitClaude } from '../reporter'

export interface InitClaudeCommandOptions {
  /** Which project to wire up. Defaults to the current directory. */
  dir?: string
}

export async function initClaudeCommand(options: InitClaudeCommandOptions = {}): Promise<void> {
  const { instructionsFile, label } = PROVIDERS[CLAUDE_PROVIDER]

  try {
    const result = await initClaude({
      cwd    : options.dir,
      onEvent: reportInitClaude,
    })

    const agents = result.created.length + result.updated.length + result.unchanged.length

    section('Next steps:')
    say(`  1. open ${ instructionsFile } and check the FlowRunner block reads the way you want`)
    say(`  2. ask ${ label } to build a service — it will pick up the ${ agents } FlowRunner ${ agents === 1 ? 'agent' : 'agents' }`)
    // The instructions are the thing the agents are pointers to, so naming the path is what makes the
    // whole arrangement inspectable rather than magic.
    say(`  3. the authoring reference lives in node_modules/flowrunner-cli/${ AI_INSTRUCTIONS_DIRECTORY }/`)
    say('')
  } catch (error) {
    fail(error)
  }
}
